export enum ETestStages {
    INIT = 'INIT',
    INIT_DOWN = 'INIT_DOWN',
    PING = 'PING',
    DOWN = 'DOWN',
    INIT_UP = 'INIT_UP',
    UP = 'UP',
    END = 'END',
    RESULT = 'RESULT'
}
